import { render } from "./upcoming_birthdays.html?vue&type=template&id=3015448c&external"
import script from "./upcoming_birthdays.js?vue&type=script&lang=js&external"
export * from "./upcoming_birthdays.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__